import { render, staticRenderFns } from "./SheetCard.vue?vue&type=template&id=3fadb6b0&scoped=true&"
import script from "./SheetCard.vue?vue&type=script&lang=js&"
export * from "./SheetCard.vue?vue&type=script&lang=js&"
import style0 from "./SheetCard.vue?vue&type=style&index=0&id=3fadb6b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fadb6b0",
  null
  
)

export default component.exports